import React from 'react'
import About from './About'
import useTitle from '../../hooks/useTitle'

const AboutMe = () => {
  useTitle("About Me")
  const skills=[
    "HTML",
    "CSS",
    "Sass",
    "Bootstrap",
    "TailwindCSS",
    "JavaScript",
    "React.js",
    "Express.js",
    "jQuery",
    "Firebase",
    "MongoDB",
    "Figma",
    "WordPress",
    "Web Design",
    "PSD to HTML",
    "Landing Pages",
    "E-commerce",
    "Woocommerce",
  ]



  return (
    <div>
      <About />
      <div className='bg-[#0E1629] py-20'>
          <div className='container'>
              <div className=''>
                <div>
                    <h1 className='text-5xl font-medium text-[#22d3ee] mb-12 text-center'>My Skills</h1>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-10'>
                  {skills.map((skill)=><div className="radial-progress text-[#22d3ee] mx-auto text-lg " style={{ "--value": "100", "--size": "12rem", "--thickness": "1.5rem" }}>{skill}</div>)}
                </div>
              </div>
          </div>
      </div>
    </div>
  )
}

export default AboutMe